const WHATSAPP_ACCOUNT = ['85257899890', '85257905149']

export const getWhatsAppLink = () => {
  return `https://api.whatsapp.com/send?phone=${
    WHATSAPP_ACCOUNT[Math.floor(Math.random() * WHATSAPP_ACCOUNT.length)]
  }&text=`
}
